import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainDelCarport(id) {
  return maintainRequest.post(`/device/maintenanceMan/carport/maintainDelCarport/${id}`);
}
